import React from "react";
import Button from "../Button";
import LayoutButtons from "../LayoutButtons";
const FilterButtons = _ref => {
  let {
    onAppliedNewSearchFilter,
    onClearFilters,
    onClose,
    labelApplyFilters,
    labelClearAllFilters,
    labelClose,
    applyEnabled = false
  } = _ref;
  return /*#__PURE__*/React.createElement(LayoutButtons, null, /*#__PURE__*/React.createElement(Button, {
    disabled: !applyEnabled,
    variant: "contained",
    onClick: onAppliedNewSearchFilter,
    "data-testid": "ListSearchFitlers_Action_ApplyFilters"
  }, labelApplyFilters), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    onClick: onClearFilters,
    "data-testid": "ListSearchFitlers_Action_ClearAllFilters"
  }, labelClearAllFilters), onClose && labelClose && /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: onClose,
    "data-testid": "ListSearchFitlers_Action_Close"
  }, labelClose));
};
export default FilterButtons;